// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2wv0h","Modal__modalContent":"Modal_Modal__modalContent__1ILfz","Modal__header":"Modal_Modal__header__1h8D9","Modal__btnclose":"Modal_Modal__btnclose__1RFVV"};